import React, { useState } from 'react';
import styled from 'styled-components';

import { GreyCapsText, RangeSlider } from 'components/core';
import useTranslation from 'src/hooks/use-translation';
import { DistanceSliderProps } from '../location-settings-popover.types';

export function DistanceSlider({ distance: initialValue, onChangeDistance }: DistanceSliderProps): JSX.Element {
  const { t } = useTranslation();

  const [localValue, setLocalValue] = useState(initialValue);

  function handleChange(_e: React.ChangeEvent, value: number): void {
    setLocalValue(value);
  }

  return (
    <Container>
      <StyledGreyCapsText>{t('locationSettings.currentAddress', 'Distance')}</StyledGreyCapsText>
      <RangeSlider
        min={1}
        max={50}
        value={localValue}
        onChange={handleChange}
        onChangeCommitted={onChangeDistance}
        aria-valuetext={t('locationSettings.distanceMiles', '{{localValue}} miles', { localValue })}
      />
      <DistanceText>
        {t('locationSettings.shopFromDispensariesWithin', 'Shop from dispensaries within')}{' '}
        <b>{t('locationSettings.distanceMiles', '{{localValue}} miles', { localValue })}</b>
      </DistanceText>
    </Container>
  );
}

const Container = styled.div`
  padding: 30px 0;
  margin: 0 30px;
  border-top: ${({ theme }) => `1px solid ${theme.colors.blueGrey[95] as string}`};
  .MuiSlider-root {
    padding-top: 15px;
    padding-bottom: 18px;
  }
`;

const StyledGreyCapsText = styled(GreyCapsText)`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.grey[70]};
`;

const DistanceText = styled.div`
  color: ${({ theme }) => theme.colors.primaryBlack};
  font-size: 14px;
`;
